module.exports = __webpack_public_path__ + "media/tâa taang yàang née rîak wâa grà dâo kôo.45d0508a.mp3";